module.exports = "/assets/data/a1039313c44df12181a0b599b7afe409-OX28.data.json";